/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stat_JobsInputs */

const en_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobs Tracked`)
};

const de_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen verfolgt`)
};

const fr_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplois suivis`)
};

const es_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empleos en seguimiento`)
};

const it_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavori Tracciati`)
};

const nl_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banen Bijgehouden`)
};

const pl_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledzone ogłoszenia`)
};

const fi_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seurattuja työpaikkoja`)
};

const da_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobsporing`)
};

const sv_dashboard_stat_jobs = /** @type {(inputs: Dashboard_Stat_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobb Spårat`)
};

/**
* | output |
* | --- |
* | "Jobs Tracked" |
*
* @param {Dashboard_Stat_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_stat_jobs = /** @type {((inputs?: Dashboard_Stat_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stat_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_stat_jobs(inputs)
	if (locale === "fr") return fr_dashboard_stat_jobs(inputs)
	if (locale === "es") return es_dashboard_stat_jobs(inputs)
	if (locale === "it") return it_dashboard_stat_jobs(inputs)
	if (locale === "nl") return nl_dashboard_stat_jobs(inputs)
	if (locale === "pl") return pl_dashboard_stat_jobs(inputs)
	if (locale === "fi") return fi_dashboard_stat_jobs(inputs)
	if (locale === "da") return da_dashboard_stat_jobs(inputs)
	if (locale === "sv") return sv_dashboard_stat_jobs(inputs)
	return en_dashboard_stat_jobs(inputs)
});